
// Extension's controller

import { Utils } from '../../'
import IndicatorSettings from './IndicatorSettings.vue'
import Vue from 'vue'

export default class Main {

    constructor(tv, dc) {
        this.widgets = {}
        this.tv = tv
        this.dc = dc
    }

    // Listens to all tvjs events, creates new widgets
    update(e) {
        switch(e.event) {
            case 'legend-button-click':
                let id = `IndicatorSettings-${Utils.uuid2()}`
                let args = e.args[0]

                if (args.button === 'settings') {
                    try {
                        let ov = this.dc.data[args.type][args.dataIndex]
                        let f = Object.values(this.widgets)
                            .find(x => x.data.ov === ov)
                        if(f) {
                            this.tv.$delete(this.widgets, f.id)
                            break
                        }
                        this.tv.$set(this.widgets, id, {
                            id, cls: IndicatorSettings, data: { ov: ov, anchor: args.anchor }
                        })
                    } catch(e) {
                    }
                } else if (args.button === 'group-settings') {
                    try {
                        let overlays = args.dataIndices.map(
                            idx => this.dc.data[args.type][idx]
                        ).filter(Boolean)
                        if (!overlays.length) break
                        // Check if group settings already open
                        let f = Object.values(this.widgets)
                            .find(x => x.data.groupName === args.groupName)
                        if (f) {
                            this.tv.$delete(this.widgets, f.id)
                            break
                        }
                        this.tv.$set(this.widgets, id, {
                            id, cls: IndicatorSettings, data: {
                                ov: null,
                                anchor: args.anchor,
                                groupName: args.groupName,
                                overlays: overlays,
                                side: args.type,
                                isGroup: true
                            }
                        })
                    } catch(e) {
                    }
                }
                break
        }
    }

    remove_widget(id) {
        this.tv.$delete(this.widgets, id)
    }

}
